import {
  DASHBOARD,
  DASHBOARD_TOTAL_VEHICLE,
  FEET_GROUP_CHILD,
  DASHBOARD_GEOFENCE_VIOLATION,
  DASHBOARD_MOVING_VEHICLE,
  DASHBOARD_IDLE_VEHICLE,
  DASHBOARD_STOP_VEHICLE,
  DASHBOARD_SILENT_VEHICLE,
  DASHBOARD_REPAIR_VEHICLE,
  AUTOCOMPLETE_DASHBOARD,
  DOWNLOAD_TOTAL,
  GET_ADDRESS,
  UPDATE_FILE_HISTORY,

  // Urgent
  DASHBOARD_GET_URGENT_ACCIDENT,
  DASHBOARD_GET_MB_CN,
  DASHBOARD_GET_DOOR_OPEN,
  DASHBOARD_GET_GEOFENCE_IN,
  DASHBOARD_GET_GEOFENCE_OUT,
  DASHBOARD_GET_OVERSTAY_ON,
  DASHBOARD_GET_OVERSTAY_OFF,
  DASHBOARD_GET_OVERTEMP,
  DASHBOARD_GET_UNDERTEMP,
  DASHBOARD_GET_GEOFENCE_PRECENTAGES,
  DASHBOARD_GET_OVERSTAY_PRECENTAGES,
  DASHBOARD_GET_TEMPERATURE_PRECENTAGES,

  // Summary
  DASHBOARD_GET_TOTAL_OVERSPEED,
  DASHBOARD_GET_TOTAL_HARSH_ACC,
  DASHBOARD_GET_TOTAL_HARSH_BRK,
  DASHBOARD_GET_TOTAL_ACCIDENT,
  DASHBOARD_GET_TOTAL_VERIFIED_ALERT,
  DASHBOARD_GET_TOTAL_UNVERIFIED_ALERT,
  DASHBOARD_GET_TOP_OVERSPEED,
  DASHBOARD_GET_TOP_HARSH_ACC,
  DASHBOARD_GET_TOP_HARSH_BRK,
  DASHBOARD_GET_TOP_ACCIDENT,
  DASHBOARD_GET_TOP_VERIFIED_ALERT,
  DASHBOARD_GET_TOP_UNVERIFIED_ALERT,

  // Analytics
  DASHBOARD_GET_OVERSPEED,
  DASHBOARD_GET_HARSH_ACC,
  DASHBOARD_GET_HARSH_BRK,
  DASHBOARD_GET_ACCIDENT,
  DASHBOARD_GET_VERIFIED_ALERT,
  DASHBOARD_GET_UNVERIFIED_ALERT,
  DASHBOARD_GET_MB_CN_ANALYTICS,
  DASHBOARD_GET_OVERSTAY_OFF_ANALYTICS,
  DASHBOARD_GET_OVERSTAY_ON_ANALYTICS,
  DASHBOARD_GET_OVERTEMP_ANALYTICS,
  DASHBOARD_GET_DOOR_OPEN_ANALYTICS,
  DASHBOARD_GET_ACTIVE_VEHICLE,
  DASHBOARD_GET_STATUS_VEHICLE,
  DASHBOARD_GET_RITATION_VEHICLE,
  DASHBOARD_GET_IN_OPERATION_VEHICLE,
  DASHBOARD_GET_UTILIZATION_RATE_VEHICLE,
  DASHBOARD_GET_STATUS_ALERT,
  DASHBOARD_GET_PRECENTAGES_OVERSTAY,
  DASHBOARD_GET_PRECENTAGES_GEOFENCE,
  DASHBOARD_GET_PRECENTAGES_TEMPERATURE,
  DASHBOARD_GET_NOT_YET_VERIFIED_ALERT,
  DASHBOARD_GET_DMS_GPS_OVERSPEED,
  DASHBOARD_GET_DMS_BASED_ON_TIME,
  DASHBOARD_GET_DMS_BASED_ON_CATEGORY,
  DASHBOARD_DOWNLOAD,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'
// const id = JSON.parse(localStorage.getItem('userInfo')).id

export const getDashboardData = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD, config_token)
}

export const getAllVehicleDownload = (param, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DOWNLOAD_TOTAL + param + '/' + id, config_token)
}

// new dashboard download endpoint
export const getVehicleDashboardDownload = (id, activity) => {
  let config_token = {
    params: { activity_type: activity, fleet_group_id: id },
    headers: REPO.getAuthHeader(),
  }
  return axios.get(`${DASHBOARD_DOWNLOAD}`, config_token)
}

export const getListFleetChield = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(FEET_GROUP_CHILD + id, config_token)
}

export const getDashboardTotalVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_TOTAL_VEHICLE + id + '?' + param, config_token)
}

export const getDashboardGeofenceViolation = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GEOFENCE_VIOLATION + id + '?' + param,
    config_token
  )
}

export const getAutocomplete = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(AUTOCOMPLETE_DASHBOARD + id + '/list?' + param, config_token)
}

export const getDashboardMovingVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_MOVING_VEHICLE + id + '?' + param, config_token)
}

export const getDashboardIdleVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_IDLE_VEHICLE + id + '?' + param, config_token)
}

export const getDashboardStopVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_STOP_VEHICLE + id + '?' + param, config_token)
}

export const getDashboardSilentVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_SILENT_VEHICLE + id + '?' + param, config_token)
}

export const getDashboardSilentVehicleCount = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_SILENT_VEHICLE + '-count/' + id + '?' + param,
    config_token
  )
}

export const getDashboardDMSGPSOverspeed = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_DMS_GPS_OVERSPEED + id + '?' + param,
    config_token
  )
}

export const getDashboardDMSBasedOnTime = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_DMS_BASED_ON_TIME + id + '?' + param,
    config_token
  )
}

export const getDashboardDMSBasedOnCategory = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_DMS_BASED_ON_CATEGORY + id + '?' + param,
    config_token
  )
}

export const addToRepairVehicle = (body, query) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(query)
  return axios.put(DASHBOARD_REPAIR_VEHICLE + '?' + param, body, config_token)
}

export const uploadManualRepairEvidence = (formData, id) => {
  const token = localStorage.getItem(localKey)
  let config_token = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token ? 'Bearer ' + token : '',
    },
  }

  return axios.post(UPDATE_FILE_HISTORY + id, formData, config_token)
}

export const getDashboardRepairVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_REPAIR_VEHICLE + '/' + id + '?' + param,
    config_token
  )
}

export const getRepairVehicleByLicensePlate = (fleetGroupId, licensePlate) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam({ license_plate: licensePlate })
  return axios.get(
    DASHBOARD_REPAIR_VEHICLE + '/' + fleetGroupId + '?' + param,
    config_token
  )
}

export const getAddress = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  body = { ...body, format: 'json' }
  const param = REPO.bikinParam(body)
  return axios.get(GET_ADDRESS + param, config_token)
}

// DASHBOARD V2
// Urgent
export const getAllDashboardUrgent = (id) => {
  const crash = getDashboardTotalAccident(id)
  const mbcn = getDashboardMbcn(id)
  const overstayOn = getDashboardOverstayOn(id)
  const overstayOff = getDashboardOverstayOff(id)
  const geofenceIn = getDashboardGeofenceIn(id)
  const geofenceOut = getDashboardGeofenceOut(id)

  const geofencePrecentages = getDashboardGeofencePrecentages(id)
  const overstayPrecentages = getDashboardOverstayPrecentages(id)
  const temperaturePrecentages = getDashboardTemperaturePrecentages(id)

  return axios.all([
    crash,
    mbcn,
    overstayOn,
    overstayOff,
    geofenceIn,
    geofenceOut,

    overstayPrecentages,
    geofencePrecentages,
    temperaturePrecentages,
  ])
}

export const getDashboardUrgentAccident = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_URGENT_ACCIDENT + id, config_token)
}

export const getDashboardMbcn = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_MB_CN + id, config_token)
}

export const getDashboardDoorOpen = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_DOOR_OPEN + id, config_token)
}

export const getDashboardGeofenceIn = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_GEOFENCE_IN + id, config_token)
}

export const getDashboardGeofenceOut = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_GEOFENCE_OUT + id, config_token)
}

export const getDashboardOverstayOn = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_OVERSTAY_ON + id, config_token)
}

export const getDashboardOverstayOff = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_OVERSTAY_OFF + id, config_token)
}

export const getDashboardOverTemp = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_OVERTEMP + id, config_token)
}

export const getDashboardUnderTemp = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_UNDERTEMP + id, config_token)
}

export const getDashboardGeofencePrecentages = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_GEOFENCE_PRECENTAGES + id, config_token)
}

export const getDashboardOverstayPrecentages = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_OVERSTAY_PRECENTAGES + id, config_token)
}

export const getDashboardTemperaturePrecentages = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_TEMPERATURE_PRECENTAGES + id, config_token)
}

// Summary
export const getAllDashboardSummary = (id) => {
  const totalOverspeed = getDashboardTotalOverspeed(id)
  const totalHarshAcc = getDashboardTotalHarshAcc(id)
  const totalHarshBrk = getDashboardTotalHarshBrk(id)

  const topOverspeed = getDashboardTopOverspeed(id)
  const topHarshAcc = getDashboardTopHarshAcc(id)
  const topHarshBrk = getDashboardTopHarshBrk(id)
  const topAccident = getDashboardTopAccident(id)
  const topVerifiedAlert = getDashboardTopVerifiedAlert(id)
  const topUnverifiedAlert = getDashboardTopUnverifiedAlert(id)

  return axios.all([
    totalOverspeed,
    totalHarshAcc,
    totalHarshBrk,
    topOverspeed,
    topHarshAcc,
    topHarshBrk,
    topAccident,
    topVerifiedAlert,
    topUnverifiedAlert,
  ])
}

export const getDashboardTotalOverspeed = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_TOTAL_OVERSPEED + id + '?' + param,
    config_token
  )
}

export const getDashboardTotalHarshAcc = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_TOTAL_HARSH_ACC + id + '?' + param,
    config_token
  )
}

export const getDashboardTotalHarshBrk = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_TOTAL_HARSH_BRK + id + '?' + param,
    config_token
  )
}

export const getDashboardTotalAccident = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_TOTAL_ACCIDENT + id, config_token)
}

export const getDashboardTotalVerifiedAlert = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_TOTAL_VERIFIED_ALERT + id, config_token)
}

export const getDashboardTotalUnverifiedAlert = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(DASHBOARD_GET_TOTAL_UNVERIFIED_ALERT + id, config_token)
}

export const getDashboardTopOverspeed = (id, body, isVehicle = false) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  if (isVehicle) {
    param = REPO.bikinParam({ ...body, type: 'vehicle' })
  }
  return axios.get(DASHBOARD_GET_TOP_OVERSPEED + id + '?' + param, config_token)
}

export const getDashboardTopHarshAcc = (id, body, isVehicle = false) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  if (isVehicle) {
    param = REPO.bikinParam({ ...body, type: 'vehicle' })
  }
  return axios.get(DASHBOARD_GET_TOP_HARSH_ACC + id + '?' + param, config_token)
}

export const getDashboardTopHarshBrk = (id, body, isVehicle = false) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  if (isVehicle) {
    param = REPO.bikinParam({ ...body, type: 'vehicle' })
  }
  return axios.get(DASHBOARD_GET_TOP_HARSH_BRK + id + '?' + param, config_token)
}

export const getDashboardTopAccident = (id, body, isVehicle = false) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  if (isVehicle) {
    param = REPO.bikinParam({ ...body, type: 'vehicle' })
  }
  return axios.get(DASHBOARD_GET_TOP_ACCIDENT + id + '?' + param, config_token)
}

export const getDashboardTopVerifiedAlert = (id, body, isVehicle = false) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  if (isVehicle) {
    param = REPO.bikinParam({ ...body, type: 'vehicle' })
  }
  return axios.get(
    DASHBOARD_GET_TOP_VERIFIED_ALERT + id + '?' + param,
    config_token
  )
}

export const getDashboardTopUnverifiedAlert = (id, body, isVehicle = false) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  if (isVehicle) {
    param = REPO.bikinParam({ ...body, type: 'vehicle' })
  }
  return axios.get(
    DASHBOARD_GET_TOP_UNVERIFIED_ALERT + id + '?' + param,
    config_token
  )
}

// Analytics
export const getAllDashboardAnalytics = (id, body) => {
  const overspeed = getDashboardOverspeed(id, body)
  const harshAcc = getDashboardHarshAcc(id, body)
  const harshBrk = getDashboardHarshBrk(id, body)
  const accident = getDashboardAccident(id, body)
  const verifiedAlert = getDashboardVerifiedAlert(id, body)
  const unverifiedAlert = getDashboardUnverifiedAlert(id, body)
  const mbcn = getDashboardMbcnAnalytics(id, body)
  const overstayOff = getDashboardOverstayOffAnalytics(id, body)
  const overstayOn = getDashboardOverstayOnAnalytics(id, body)
  const geofenceOut = getDashboardGeofenceOut(id, body)
  const overTemp = getDashboardOverTempAnalytics(id, body)
  const doorOpen = getDashboardDoorOpenAnalytics(id, body)

  const statusVehicle = getDashboardStatusVehicle(id, body)
  const activeVehicle = getDashboardActiveVehicle(id, body)
  const topOverspeed = getDashboardTopOverspeed(id, body)
  const overstayPrecentages = getDashboardPrecentagesOverstay(id, body)
  // const geofencePrecentages = getDashboardPrecentagesGeofence(id)
  // const temperaturePrecentages = getDashboardPrecentagesTemperature(id)

  return axios.all([
    overspeed,
    harshAcc,
    harshBrk,
    accident,
    verifiedAlert,
    unverifiedAlert,
    mbcn,
    overstayOff,
    overstayOn,
    geofenceOut,
    overTemp,
    doorOpen,

    statusVehicle,
    activeVehicle,
    topOverspeed,
    overstayPrecentages,
  ])
}

export const getDashboardOverspeed = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_GET_OVERSPEED + id + '?' + param, config_token)
}

export const getDashboardHarshAcc = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_GET_HARSH_ACC + id + '?' + param, config_token)
}

export const getDashboardHarshBrk = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_GET_HARSH_BRK + id + '?' + param, config_token)
}

export const getDashboardAccident = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_GET_ACCIDENT + id + '?' + param, config_token)
}

export const getDashboardVerifiedAlert = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_VERIFIED_ALERT + id + '?' + param,
    config_token
  )
}

export const getDashboardUnverifiedAlert = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_UNVERIFIED_ALERT + id + '?' + param,
    config_token
  )
}

export const getDashboardNotYetVerifiedAlert = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_NOT_YET_VERIFIED_ALERT + id + '?' + param,
    config_token
  )
}

export const getDashboardMbcnAnalytics = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_MB_CN_ANALYTICS + id + '?' + param,
    config_token
  )
}

export const getDashboardOverstayOffAnalytics = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_OVERSTAY_OFF_ANALYTICS + id + '?' + param,
    config_token
  )
}

export const getDashboardOverstayOnAnalytics = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_OVERSTAY_ON_ANALYTICS + id + '?' + param,
    config_token
  )
}

export const getDashboardOverTempAnalytics = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_OVERTEMP_ANALYTICS + id + '?' + param,
    config_token
  )
}

export const getDashboardDoorOpenAnalytics = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_DOOR_OPEN_ANALYTICS + id + '?' + param,
    config_token
  )
}

export const getDashboardActiveVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_ACTIVE_VEHICLE + id + '?' + param,
    config_token
  )
}

export const getDashboardStatusVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_STATUS_VEHICLE + id + '?' + param,
    config_token
  )
}

export const getDashboardTotalRitationVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_RITATION_VEHICLE + id + '?' + param,
    config_token
  )
}

export const getDashboardInOperationVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_IN_OPERATION_VEHICLE + id + '?' + param,
    config_token
  )
}

export const getDashboardUtilizationVehicle = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_UTILIZATION_RATE_VEHICLE + id + '?' + param,
    config_token
  )
}

// export const getDashboardUtilizationVehicle = (id, body) => {
//   let config_token = {
//     headers: REPO.getAuthHeader(),
//   }
//   let param = REPO.bikinParam(body)
//   return axios.get(
//     DASHBOARD_GET_UTILIZATION_RATE_VEHICLE + id + '?' + param,
//     config_token
//   )
// }

export const getDashboardStatusAlert = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(DASHBOARD_GET_STATUS_ALERT + id + '?' + param, config_token)
}

export const getDashboardPrecentagesOverstay = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_PRECENTAGES_OVERSTAY + id + '?' + param,
    config_token
  )
}

export const getDashboardPrecentagesGeofence = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_PRECENTAGES_GEOFENCE + id + '?' + param,
    config_token
  )
}

export const getDashboardPrecentagesTemperature = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)
  return axios.get(
    DASHBOARD_GET_PRECENTAGES_TEMPERATURE + id + '?' + param,
    config_token
  )
}
